import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DeepSeaCoralReefTerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.DEEP_SEA_CORAL_REEF;
}

export default DeepSeaCoralReefTerrainTileEntity;
